import { ModelSagres } from "@/types/model-sagres";
import { EmendaResumida } from "./emenda-resumida";

export class RetornoListaEmendas extends ModelSagres {
    emendas: EmendaResumida[];
    page: number;
    pageSize: number;
    totalRows: number;
    totalPages: number;

    constructor(obj?: any) {
        super();
        if (obj) {
            if (obj.emendas) this.emendas = obj.emendas.map((e: any) => new EmendaResumida(e))
            if (obj.page) this.page = obj.page
            if (obj.pageSize) this.pageSize = obj.pageSize
            if (obj.totalRows) this.totalRows = obj.totalRows
            if (obj.totalPages) this.totalPages = obj.totalPages
        }
    }
}